import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { I18NextPipe, I18NextService } from 'angular-i18next';
import { TableCellDirective, TableGridComponent } from 'mbs-ui-kit';
import { RenewLicense } from 'mbs-ui-shared@components/components/models/license.model';
import { LicensesPipesModule } from 'mbs-ui-shared@components/licenses/pipes/licenses-pipes.module';
import { getTableHeaders } from './constants/table';

@Component({
  selector: 'mbs-renewal-table',
  templateUrl: './renewal-table.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, LicensesPipesModule, I18NextPipe, TableGridComponent, TableCellDirective]
})
export class RenewalTableComponent {
  private i18n = inject(I18NextService);
  public tableMaxHeight = input<string>('50vh');

  public licenses = input<Array<RenewLicense>>();
  public period = input<string>();
  public isProratedColumnShown = input<boolean>(null);
  public loading = input<boolean>(false);

  protected headers = computed(() => getTableHeaders(this.i18n, this.isProratedColumnShown()));
}
